import { JSONSchemaType } from "ajv";

import { DefaultSchemaValue } from "../../../verification/shared/enums/default-schema-value";
import { schemaNullableField } from "../../../verification/shared/utils/schema-nullable-field";

import { IMateriallyAccountableEmployeeDto } from "./materially-accountable-employee.dto";

export const MateriallyAccountableEmployeeSchema: JSONSchemaType<IMateriallyAccountableEmployeeDto> =
  {
    type: "object",
    properties: {
      id: { type: "string", default: DefaultSchemaValue.STRING },
      personalId: { type: "string", default: DefaultSchemaValue.STRING },
      farmId: { type: "string", default: DefaultSchemaValue.STRING },
      name: { type: "string", default: DefaultSchemaValue.STRING },
      isDeleted: { type: "boolean", default: false },
      deletedAt: schemaNullableField({ type: "string" }),
      createdAt: schemaNullableField({ type: "string" }),
      updatedAt: schemaNullableField({ type: "string" }),
      createdByUserId: schemaNullableField({ type: "string" }),
      updatedByUserId: schemaNullableField({ type: "string" }),
    },
    required: [
      "id",
      "personalId",
      "farmId",
      "name",
      "isDeleted",
      "deletedAt",
      "createdAt",
      "updatedAt",
      "createdByUserId",
      "updatedByUserId",
    ],
  };

export const MateriallyAccountableEmployeeListSchema: JSONSchemaType<
  IMateriallyAccountableEmployeeDto[]
> = {
  type: "array",
  items: MateriallyAccountableEmployeeSchema,
};
